import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import MainLayout from '../../layouts/MainLayout';

import Error404Picture from '../../assets/img/draw-kit/error_404.svg';

const NotFound = () => {
    return (
        <MainLayout pageTitle="Oops..">
            <Container>
                <Row>
                    <Col col={12} style={{ marginTop: '20px', textAlign: 'center' }}>
                        <img src={Error404Picture} height={350}/>
                        <h1 style={{marginTop: 25}}>Page not found</h1>
                    </Col>
                </Row>
            </Container>
        </MainLayout>
    );
}

export default NotFound;